/* eslint-disable import/prefer-default-export */

import { createAction } from "redux-actions";
import * as types from "./constants";

export const setElabUser = createAction(types.SET_ELAB_USER);
export const setElabUserFailed = createAction(types.SET_ELAB_USER_FAILED);
export const setStorageLocations = createAction(types.SET_STORAGE_LOCATIONS);
export const setSampleTypes = createAction(types.SET_SAMPLE_TYPES);
export const setSampleType = createAction(types.SET_SAMPLE_TYPE);
export const setColumnDefs = createAction(types.SET_COL_DEFS);
export const setUsername = createAction(types.SET_USERNAME);
export const setPassword = createAction(types.SET_PASSWORD);
export const toggle = createAction(types.TOGGLE);
